<template>
  <div class="product-basic-info-form">
    <el-row :gutter="16">
      <custom-input
        v-model="localModel.Descripcion"
        :span-column="isCompact ? 6 : 8"
        label="Descripción"
        :class="{ 'validation-error': !props.validacionEstados?.descripcionValida }"
        :settings="{
          placeholder: isCompact
            ? 'Ingrese la descripción'
            : 'Ingrese la descripción del producto personalizado',
          required: !isCompact,
        }"
      />
      <custom-select
        v-model="localModel.ElementoBase"
        :span-column="isCompact ? 6 : 8"
        label="Elemento Base"
        :class="{ 'validation-error': !props.validacionEstados?.elementoBaseValido }"
        :settings="{
          placeholder: 'Seleccione elemento base',
          options: elementosBase,
          clearable: false,
          required: !isCompact,
        }"
      />
      <custom-switch
        v-model="localModel.Activo"
        :span-column="isCompact ? 6 : 4"
        label="Estado Activo"
      />
    </el-row>
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  watch,
  onMounted,
} from 'vue';
import { useElementoBaseStore } from '@/stores/elemento_base/elemento_base_store.js';
import CustomInput from '@/shared/components/custom_input.vue';
import CustomSelect from '@/shared/components/custom_select.vue';
import CustomSwitch from '@/shared/components/custom_switch.vue';

// Props
const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
    default: () => ({
      Descripcion: '',
      ElementoBase: null,
      Activo: true,
    }),
  },
  isCompact: {
    type: Boolean,
    default: false,
  },
  validacionEstados: {
    type: Object,
    default: () => ({
      descripcionValida: true,
      elementoBaseValido: true,
    }),
  },
});

// Emits
const emit = defineEmits(['update:modelValue']);

const localModel = computed(
  {
    get: () => props.modelValue,
    set: (value) =>
      emit('update:modelValue', {
        ...props.modelValue,
        ElementoBase: value.ElementoBase,
        Descripcion: value.Descripcion,
        Activo: value.Activo,
      }),
  },
  {
    deep: true,
  },
);

const elementoBaseStore = useElementoBaseStore();

const elementosBase = ref([]);

// Cargar elementos base
const cargarElementosBase = async () => {
  try {
    await elementoBaseStore.firstElementoBase();
    elementosBase.value = elementoBaseStore.elementosBase || [];
  } catch (error) {
    console.error('Error al cargar elementos base:', error);
    elementosBase.value = [];
  }
};

// Computed para validación (se puede usar externamente)
const isValid = computed(() => {
  const tieneDescripcion =
    localModel.value.Descripcion && localModel.value.Descripcion.trim().length >= 3;
  const tieneElementoBase = localModel.value.ElementoBase && localModel.value.ElementoBase.Codigo;
  console.log('Validación del formulario:', {
    descripcion: localModel.value.Descripcion,
    elementoBase: localModel.value.ElementoBase,
    tieneDescripcion,
    tieneElementoBase,
    isValid: !!(tieneDescripcion && tieneElementoBase),
  });
  return !!(tieneDescripcion && tieneElementoBase);
});

// Exponer computed para uso externo
defineExpose({
  isValid,
});

// Lifecycle
onMounted(() => {
  cargarElementosBase();
});
</script>

<style scoped>
.product-basic-info-form {
  margin-bottom: 16px;
}
</style>
